import { Alert } from "~/logic/alert.logic"
import { useAuthStore } from "~/stores"

export class ErrorLogic {
    constructor(LaravelErrorData) {
        this.handle(LaravelErrorData)
    }

    async handle(LaravelErrorData) {
        switch (LaravelErrorData.code) {
            case "UNAUTHORIZED":
            case "UNAUTHENTICATED":
                await this.handleUnauthorizedError()
                break
            case "VALIDATION_ERROR":
                await this.handleBadParamsError(LaravelErrorData)
                break
            default:
                await this.handleDefaultError(LaravelErrorData)
                break
        }
    }

    async handleBadParamsError(LaravelErrorData) {
        let messageErrors = ""
        const errors = LaravelErrorData.errors

        for (const key in errors) {
            const error = errors[key]
            for (const message of error) {
                messageErrors += message + "<br><br>"
            }
        }

        await Alert.errorBlocking({
            title: "Mauvais parametres",
            message: messageErrors,
        })
    }

    async handleUnauthorizedError() {
        const authStore = useAuthStore()
        await authStore.logout()
        Alert.errorBlocking({
            title: "Non autorisé",
            message: "Vous n'êtes pas autorisé à effectuer cette action.",
        })
    }

    async handleDefaultError(LaravelErrorData) {
        Alert.errorBlocking({
            title: "Erreur",
            message: LaravelErrorData.message,
        })
    }
}
